import React from 'react';

import SelectBox   from '../SelectBox';
import Label       from '../Label';
import InlineError from '../InlineError';

class TimetableSelect extends React.Component {

    render() {

        return (
            <div>
                <Label isRequired="true">Timetable</Label>

                <SelectBox { ...this.props.timetableId } errors={ this.props.timetableId.error }>

                    <option value="">No timetable</option>

                    {
                        this.props.timetables.map((timetable, index) => {

                            return (
                                <option key={ index } value={ timetable.id }>
                                    { timetable.name }
                                </option>
                            )
                        })
                    }

                </SelectBox>

                <InlineError errors={ this.props.timetableId.error } />
            </div>
        );
    }
}

export default TimetableSelect;


// WEBPACK FOOTER //
// ./components/TimetableSelect/index.js